/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCompleteOTPResponse
 */
export interface ControlCompleteOTPResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteOTPResponse
     */
    access_token: string;
}

/**
 * Check if a given object implements the ControlCompleteOTPResponse interface.
 */
export function instanceOfControlCompleteOTPResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "access_token" in value;

    return isInstance;
}

export function ControlCompleteOTPResponseFromJSON(json: any): ControlCompleteOTPResponse {
    return ControlCompleteOTPResponseFromJSONTyped(json, false);
}

export function ControlCompleteOTPResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCompleteOTPResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': json['access_token'],
    };
}

export function ControlCompleteOTPResponseToJSON(value?: ControlCompleteOTPResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
    };
}

